module.exports = __webpack_public_path__ + "static/media/120.e2f8e1b1.png";